import { gql } from '@apollo/client';

export interface AuthenticatedItemResponse {
    authenticatedItem: {
        id: string;
        email: string;
        name: string;
        role: string;
        teacherProfile?: {
            id: string;
            schools: {
                id: string;
                name: string;
                schoolName: string;
                isDefault: boolean;
            }[];
        };
    };
}

export const GET_SESSION = gql`
    query AuthenticatedItem {
        authenticatedItem {
            ... on User {
                id
                name
                email
                role
                teacherProfile {
                    id
                    schools {
                        id
                        name
                        schoolName
                        isDefault
                    }
                }
            }
        }
    }
`;
